<template>
  <div class="player">
    <div class="float">
      <img :src="starIcon" style="width: 28px" @click="collection"/>
    </div>
    <video v-for="e in element" id="video" :key="e" class="video-js vjs-default-skin">
      you are browser not support html5.
    </video>
  </div>
</template>

<script>
import 'video.js/dist/video-js.min.css'
import videojs from 'video.js'
import 'videojs-flash'
import { Message } from 'element-ui'
import basic from '@/model/zone'
import { mapState } from 'vuex'

export default {
  name: 'Player',
  data () {
    return {
      player: null,
      element: [1],
      device: { id: 1, type: 'video' }
    }
  },
  computed: {
    ...mapState(['zone']),
    isCollection () {
      return this.$store.state.collection.devices.filter(s => s.id === this.device.id && s.type === this.device.type).length
    },
    starIcon () {
      if (this.isCollection) {
        return require('../assets/images/scene/ysc.png')
      } else {
        return require('../assets/images/scene/sc.png')
      }
    }
  },
  activated () {
    if (!this.player) {
      this.element = [1]
      this.$nextTick(() => {
        this.initVideo()
        this.$emit('success')
      })
    }
  },
  deactivated () {
    this.player && this.player.dispose()
    this.player = null
    this.element = []
  },
  destroyed () {
    this.player && this.player.dispose()
    this.player = null
    this.element = []
  },
  async mounted () {
    if (!this.zone) {
      await basic.getBasicInfo()
      this.initVideo()
    } else {
      this.initVideo()
    }
    this.$hub.$on('fullscreen', () => {
      if (this.player && this.player.requestFullscreen) {
        // 全屏
        this.player.requestFullscreen()
      }
    })
  },
  methods: {
    initVideo () {
      // debugger
      const exist = this.$config.monitor.filter(m => m.no === this.zone.no)
      if (exist.length) {
        const src = exist[0].src
        this.player = videojs('video', {
          muted: true,
          autoplay: true,
          controls: true,
          live: true,
          preload: true,
          sources: src.map(s => {
            if (s.includes('m3u8')) {
              return { src: s, type: 'application/x-mpegURL' }
            } else if (s.includes('.flv')) {
              return { src: s, type: 'rtmp/flv' }
            } else {
              return { src: s, type: 'rtmp/mp4' }
            }
          }),
          techOrder: ['flash', 'html5'] // 兼容顺序
        })
        this.player.ready(() => {
          const promise = this.player.play()
          if (promise !== undefined) {
            promise.catch((e) => {
              if (e.message !== 'The operation was aborted.') {
                Message.warning('当前设备不支持自动播放，请手动点击播放按钮')
              }
            })
          }
        })
      } else {
        Message.error('未找到视频播放源')
      }
    },
    collection () {
      // 进行相应的收藏或取消收藏操作
      if (this.isCollection) {
        this.$store.commit('UN_COLLECT', {
          type: 'device',
          data: { id: this.device.id, type: this.device.type, remark: '视频监控' }
        })
      } else {
        this.$store.commit('COLLECT', {
          type: 'device',
          data: { id: this.device.id, type: this.device.type, remark: '视频监控' }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.player {
  flex-grow: 1;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  > .float {
    position: absolute;
    right: 0px;
    z-index: 999999;
    cursor: pointer;
    > img {
      cursor: pointer;
    }
  }
  > .video-js {
    flex-grow: 1;
    height: 100%;
    width: 100%;
  }
}
</style>
